import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Github, Slack, Bell, Check, Settings } from "lucide-react";

export default function Connections() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <h1 className="text-2xl font-heading font-bold">Healion.ai</h1>
            <nav className="hidden md:flex gap-6">
              <Link to="/dashboard" className="text-sm text-muted-foreground hover:text-foreground">
                Dashboard
              </Link>
              <Link to="/errors" className="text-sm text-muted-foreground hover:text-foreground">
                Errors
              </Link>
              <Link to="/connections" className="text-sm font-medium border-b-2 border-foreground pb-1">
                Connections
              </Link>
              <Link to="/analytics" className="text-sm text-muted-foreground hover:text-foreground">
                Analytics
              </Link>
              <Link to="/settings" className="text-sm text-muted-foreground hover:text-foreground">
                Settings
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-heading font-bold mb-2">Connections</h1>
        <p className="text-muted-foreground mb-8">Manage your integrations and connections</p>

        <div className="space-y-6">
          {/* GitHub */}
          <Card className="p-6 border-2">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-foreground text-background flex items-center justify-center">
                  <Github className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg">GitHub</h3>
                  <p className="text-sm text-muted-foreground">Create pull requests with fixes</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-green-600 flex items-center gap-1">
                  <Check className="w-4 h-4" />
                  Connected
                </span>
                <Button variant="outline" size="sm">
                  <Settings className="w-4 h-4" />
                </Button>
              </div>
            </div>
            <div className="bg-muted p-4 rounded-lg space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Account:</span>
                <span className="font-medium">acme-inc</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Repositories:</span>
                <span className="font-medium">5 connected</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">PRs created:</span>
                <span className="font-medium">247 total</span>
              </div>
            </div>
            <div className="mt-4 flex gap-2">
              <Button variant="outline" size="sm">Reconnect</Button>
              <Button variant="outline" size="sm">Configure Repositories</Button>
            </div>
          </Card>

          {/* Slack */}
          <Card className="p-6 border-2">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-foreground text-background flex items-center justify-center">
                  <Slack className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg">Slack</h3>
                  <p className="text-sm text-muted-foreground">Get notified about fixes</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-green-600 flex items-center gap-1">
                  <Check className="w-4 h-4" />
                  Connected
                </span>
                <Button variant="outline" size="sm">
                  <Settings className="w-4 h-4" />
                </Button>
              </div>
            </div>
            <div className="bg-muted p-4 rounded-lg space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Workspace:</span>
                <span className="font-medium">Acme Inc.</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Channel:</span>
                <span className="font-medium">#engineering</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Notifications:</span>
                <span className="font-medium">Enabled</span>
              </div>
            </div>
            <div className="mt-4 flex gap-2">
              <Button variant="outline" size="sm">Reconnect</Button>
              <Button variant="outline" size="sm">Configure Channels</Button>
            </div>
          </Card>

          {/* Sentry */}
          <Card className="p-6 border-2">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-foreground text-background flex items-center justify-center">
                  <Bell className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg">Sentry</h3>
                  <p className="text-sm text-muted-foreground">Error monitoring</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-green-600 flex items-center gap-1">
                  <Check className="w-4 h-4" />
                  Connected
                </span>
                <Button variant="outline" size="sm">
                  <Settings className="w-4 h-4" />
                </Button>
              </div>
            </div>
            <div className="bg-muted p-4 rounded-lg space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Organization:</span>
                <span className="font-medium">acme-inc</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Projects:</span>
                <span className="font-medium">3 connected</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Errors tracked:</span>
                <span className="font-medium">1,247 this month</span>
              </div>
            </div>
            <div className="mt-4 flex gap-2">
              <Button variant="outline" size="sm">Reconnect</Button>
              <Button variant="outline" size="sm">Test Connection</Button>
            </div>
          </Card>

          {/* Optional Integrations */}
          <div className="mt-8">
            <h2 className="text-xl font-heading font-bold mb-4">Optional Integrations</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Card className="p-6 border-2 border-dashed">
                <h3 className="font-medium mb-2">FullStory</h3>
                <p className="text-sm text-muted-foreground mb-4">Session replay integration</p>
                <Button variant="outline" size="sm">Connect</Button>
              </Card>
              <Card className="p-6 border-2 border-dashed">
                <h3 className="font-medium mb-2">LogRocket</h3>
                <p className="text-sm text-muted-foreground mb-4">Session replay integration</p>
                <Button variant="outline" size="sm">Connect</Button>
              </Card>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
